import React from 'react';
import { Tooltip } from '@mui/material';

interface CorrectnessBarProps {
    percent: number;
    onClick: () => void;
}

// Side-by-side green/red bar — green portion = percent correct, red = the rest.
// Clickable (and keyboard-accessible) to open a per-student breakdown.
const CorrectnessBar: React.FC<CorrectnessBarProps> = ({ percent, onClick }) => {
    const clamped = Math.max(0, Math.min(100, percent ?? 0));
    return (
        <Tooltip arrow title={`${clamped}% correct – click for student breakdown`}>
            <div
                onClick={onClick}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        onClick();
                    }
                }}
                style={{
                    display: 'flex',
                    height: 18,
                    width: '100%',
                    minWidth: 80,
                    borderRadius: 4,
                    overflow: 'hidden',
                    boxShadow: 'inset 0 0 2px #ccc',
                    cursor: 'pointer',
                }}
            >
                <div style={{ width: `${clamped}%`, background: '#22c55e' }} />
                <div style={{ width: `${100 - clamped}%`, background: '#ef4444' }} />
            </div>
        </Tooltip>
    );
};

export default CorrectnessBar;
